import { parseNumber } from '@progress/kendo-intl';
import { FC, useMemo } from 'react';
import ReactDOMServer from 'react-dom/server';
import { preventDefault } from 'src/utils';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

interface OcrIndicatorProps {
  isEdited: boolean;
  ocrConfidence: string | null | undefined;
  onHover?: () => void;
}

const OcrIndicator: FC<OcrIndicatorProps> = ({ isEdited, ocrConfidence, onHover }) => {
  const invoice = useContextSelector(InvoiceContext, (value) => value.invoice);

  const bgColor = useMemo(() => {
    const ocrValue = parseNumber(ocrConfidence || '0%');
    if (isEdited) {
      return '#aaaaaa';
    }
    return ocrValue >= parseNumber(invoice.ocrConfidencePercentage || '0%') ? '#94c849' : '#e0aa69';
  }, [invoice.ocrConfidencePercentage, isEdited, ocrConfidence]);

  const tooltipContent = (
    <span>
      {isEdited ? 'Edited' : `OCR Confidence: `}
      <strong>{isEdited ? '' : `${ocrConfidence ?? ''}`}</strong>
    </span>
  );

  return (
    <div className="relative inline-block cursor-pointer">
      <div
        className={`h-[20px] w-[20px] text-[8px] rounded-full text-white flex items-center justify-center font-bold p-1 `}
        style={{ backgroundColor: bgColor }}
        data-tooltip-id="ocr-tooltip"
        data-tooltip-html={ReactDOMServer.renderToStaticMarkup(tooltipContent)}
        onMouseEnter={onHover}
        onDragStart={preventDefault}
        onDragOver={preventDefault}
      >
        OCR
      </div>
    </div>
  );
};

export default OcrIndicator;
